import type { LanguageItem } from '@workspace/shared/components/LanguagePicker';

import { company } from '~/company/Company';

import { LOCALE } from './constants';

/** Builds the language items for the company's configured locales */
export const getLanguageItems = (): LanguageItem[] =>
  (company.config.langs ?? []).reduce<LanguageItem[]>((items, code) => {
    const locale = LOCALE[code as keyof typeof LOCALE];
    if (!locale) return items;

    items.push({
      code,
      title: locale.title,
      label: 'label' in locale ? locale.label : undefined,
      img: locale.img,
    });

    return items;
  }, []);
